<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">Manage Pass Options</h3>
                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <!-- Form -->
        <form @submit.prevent="save">
            <div class="form-group row align-items-center">
                <label class="col-md-1 mb-0 fit-content">Company</label>
                <div class="col-md-5 pl-md-0 fit-content">
                    <select class="custom-select" v-model="company" @change="getCorporatePassOption">
                        <option v-for="(item, i) in companies" :key="i" :value="item.CompanyName">
                            {{ item.CompanyName }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="py-1"></div>

            <h4>Email Setting</h4>
            <div class="form-group row align-items-center mb-2">
                <div class="col-md-1 fit-content pt-3px pr-2">
                    <input type="checkbox" v-model="hasEmailNotification" id="chkEmailNotification" />
                </div>
                <label for="chkEmailNotification" class="col-md-6 pl-md-0 mb-0">
                    Email notification for pass booking and cancellation
                </label>
            </div>
            <div class="form-group row align-items-center mb-2">
                <div class="col-md-1 mw-20px">
                </div>
                <div class="col-md-1 fit-content pt-3px px-2">
                    <input type="checkbox" v-model="isEmailSentToEmployee" id="chkEmployee"
                        :disabled="!hasEmailNotification" />
                </div>
                <label for="chkEmployee" class="col-md-3 pl-md-0 mb-0">Employee</label>
            </div>
            <div class="form-group row align-items-center mb-2">
                <div class="col-md-1 mw-20px">
                </div>
                <div class="col-md-1 fit-content pt-3px px-2">
                    <input type="checkbox" v-model="isEmailSentToNonAdmin" id="chkSendTo"
                        :disabled="!hasEmailNotification" />
                </div>
                <label for="chkSendTo" class="col-md-1 px-md-0 mb-0 fit-content">Sent to</label>
                <div class="col-md-5 px-10px">
                    <input type="email" class="form-control form-control-sm" maxlength="500" v-model="nonAdminEmails"
                        multiple :required="isEmailSentToNonAdmin"
                        :disabled="!hasEmailNotification || !isEmailSentToNonAdmin" />
                </div>
            </div>
            <div class="form-group row align-items-center mb-2">
                <div class="col-md-1 mw-20px">
                </div>
                <div class="col-md-1 fit-content pt-3px px-2">
                    <input type="checkbox" v-model="hasCollectionReminder" id="chkCollectionReminder"
                        :disabled="!hasEmailNotification" />
                </div>
                <label for="chkCollectionReminder" class="col-md-2 px-md-0 mb-0 fit-content">
                    Pass collection reminder
                </label>
                <div class="col-md-1 px-10px fit-content">
                    <input type="number" class="form-control form-control-sm w-70px" min="1" max="999"
                        v-model="collectionReminderDay" :required="hasCollectionReminder"
                        :disabled="!hasEmailNotification || !hasCollectionReminder" />
                </div>
                <label for="chkCollectionReminder" class="col-md-2 px-md-0 mb-0 fit-content">
                    days before booking day
                </label>
            </div>
            <div class="form-group row align-items-center">
                <div class="col-md-1 mw-20px">
                </div>
                <div class="col-md-1 fit-content pt-3px px-2">
                    <input type="checkbox" v-model="hasReturnReminder" id="chkReturnReminder"
                        :disabled="!hasEmailNotification" />
                </div>
                <label for="chkReturnReminder" class="col-md-2 px-md-0 mb-0 fit-content">
                    Pass return reminder
                </label>
                <div class="col-md-1 px-10px fit-content">
                    <input type="number" class="form-control form-control-sm w-70px" min="1" max="999"
                        v-model="returnReminderDay" :required="hasReturnReminder"
                        :disabled="!hasEmailNotification || !hasReturnReminder" />
                </div>
                <label for="chkReturnReminder" class="col-md-2 px-md-0 mb-0 fit-content">
                    days after booking day
                </label>
            </div>

            <div class="py-1"></div>

            <h4>Booking Setting</h4>
            <div class="form-group row align-items-center mb-2">
                <label class="col-md-2 pr-md-0 mb-0 fit-content">
                    Holiday Template
                </label>
                <div class="col-md-5 fit-content px-10px">
                    <select class="custom-select custom-select-sm" v-model="holidayTemplate" required>
                        <option value="">-- Please Select --</option>
                        <option value="Singapore Holidays">Singapore Holidays</option>
                        <option value="Malaysia Holidays">Malaysia Holidays</option>
                    </select>
                </div>
            </div>
            <div class="form-group row align-items-center mb-2">
                <label class="col-md-1 pr-md-0 mb-0 fit-content">
                    Limited to
                </label>
                <div class="col-md-1 px-10px fit-content">
                    <input type="number" class="form-control form-control-sm w-70px" min="1" max="999"
                        v-model="maxBookingPerPassYearly" />
                </div>
                <label class="col-md-2 px-md-0 mb-0 fit-content">
                    booking/s per pass yearly
                </label>
            </div>
            <div class="form-group row align-items-center mb-2">
                <label class="col-md-1 pr-md-0 mb-0 fit-content">
                    Limited to
                </label>
                <div class="col-md-1 px-10px fit-content">
                    <input type="number" class="form-control form-control-sm w-70px" min="1" max="999"
                        v-model="maxBookingPerPassQuarterly" />
                </div>
                <label class="col-md-2 px-md-0 mb-0 fit-content">
                    booking/s per pass quarterly
                </label>
            </div>
            <div class="form-group row align-items-center">
                <div class="col-md-1 fit-content pt-3px pr-2">
                    <input type="checkbox" v-model="isAllowCancellation" id="chkAllowCancellation" />
                </div>
                <label for="chkAllowCancellation" class="col-md-2 px-md-0 mb-0 fit-content">
                    Allow cancellation
                </label>
                <div class="col-md-1 px-10px fit-content">
                    <input type="number" class="form-control form-control-sm w-70px" min="1" max="999"
                        v-model="cancellationDayBeforeBookingDate" :required="isAllowCancellation"
                        :disabled="!isAllowCancellation" />
                </div>
                <label for="chkAllowCancellation" class="col-md-2 pl-md-0 mb-0 fit-content">
                    days before booking date
                </label>
            </div>
            <!--<div class="form-group row align-items-center">
                <div class="col-md-1 fit-content pt-3px pr-2">
                    <input type="checkbox" v-model="isEticketBlockedOnPHAndEve" id="chkBlockPublicHoliday" />
                </div>
                <label for="chkBlockPublicHoliday" class="col-md-5 px-md-0 mb-0 fit-content">
                    E-tickets cannot be used during eve of Public Holidays and on Public Holiday
                </label>
            </div>-->
            <div class="form-group row align-items-center">
                <div class="col-md-1">
                    <button type="submit" class="btn btn-primary">Save</button>
                </div>
            </div>
        </form>
        <!-- /Form -->

    </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";

export default {
    data() {
        return {
            companies: [],
            company: config.DEFAULT_COMPANY,
            hasEmailNotification: false,
            isEmailSentToEmployee: false,
            isEmailSentToNonAdmin: false,
            nonAdminEmails: "",
            hasCollectionReminder: false,
            collectionReminderDay: "",
            hasReturnReminder: false,
            returnReminderDay: "",
            holidayTemplate: "",
            maxBookingPerPassYearly: "",
            maxBookingPerPassQuarterly: "",
            isAllowCancellation: false,
            cancellationDayBeforeBookingDate: "",
            isEticketBlockedOnPHAndEve: false
        }
    },

    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        },
    },

    methods: {
        getCompanies() {
            let param = {
                Token: this.token,
            };
            this.$store.state.isLoading = true;
            API.getCompanies(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.companies = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getCorporatePassOption() {
            let param = {
                Token: this.token,
                Company: this.company
            };
            this.$store.state.isLoading = true;
            API.getCorporatePassOption(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        let data = response.data.record;
                        if (data) {
                            this.hasEmailNotification = data.HasEmailNotification;
                            this.isEmailSentToEmployee = data.IsEmailSentToEmployee;
                            this.isEmailSentToNonAdmin = data.IsEmailSentToNonAdmin;
                            this.nonAdminEmails = data.NonAdminEmails;
                            this.hasCollectionReminder = data.HasCollectionReminder;
                            this.collectionReminderDay = data.CollectionReminderDay;
                            this.hasReturnReminder = data.HasReturnReminder;
                            this.returnReminderDay = data.ReturnReminderDay;
                            this.holidayTemplate = data.HolidayTemplate;
                            this.maxBookingPerPassYearly = data.MaxBookingPerPassYearly;
                            this.maxBookingPerPassQuarterly = data.MaxBookingPerPassQuarterly;
                            this.isAllowCancellation = data.IsAllowCancellation;
                            this.cancellationDayBeforeBookingDate = data.CancellationDayBeforeBookingDate;
                            this.isEticketBlockedOnPHAndEve = data.IsEticketBlockedOnPHAndEve;
                        } else {
                            this.resetData();
                        }
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        save() {
            let param = {
                Token: this.token,
                Company: this.company,
                HasEmailNotification: this.hasEmailNotification,
                IsEmailSentToEmployee: this.isEmailSentToEmployee,
                IsEmailSentToNonAdmin: this.isEmailSentToNonAdmin,
                NonAdminEmails: this.nonAdminEmails,
                HasCollectionReminder: this.hasCollectionReminder,
                CollectionReminderDay: this.collectionReminderDay,
                HasReturnReminder: this.hasReturnReminder,
                ReturnReminderDay: this.returnReminderDay,
                HolidayTemplate: this.holidayTemplate,
                MaxBookingPerPassYearly: this.maxBookingPerPassYearly,
                MaxBookingPerPassQuarterly: this.maxBookingPerPassQuarterly,
                IsAllowCancellation: this.isAllowCancellation,
                CancellationDayBeforeBookingDate: this.cancellationDayBeforeBookingDate,
                IsEticketBlockedOnPHAndEve: this.isEticketBlockedOnPHAndEve
            }
            this.$swal({
                title: "Are you sure?",
                text: "Are you sure you want to save the pass options?",
                icon: "info",
                buttons: true,
                dangerMode: false,
            }).then((willSave) => {
                if (willSave) {
                    this.$store.state.isLoading = true;
                    API.saveCorporatePassOption(param)
                        .then((response) => {
                            this.$store.state.isLoading = false;
                            this.$swal(response.data.message, {
                                icon: response.data.success ? "success" : "error",
                            });
                        })
                        .catch((error) => {
                            console.log(error)
                            this.$store.state.isLoading = false;
                            this.$swal(error.response.data.Message, { icon: "error" });
                        });
                }
            });
        },
        //helper
        resetData() {
            this.hasEmailNotification = false;
            this.isEmailSentToEmployee = false;
            this.isEmailSentToNonAdmin = false;
            this.nonAdminEmails = "";
            this.hasCollectionReminder = false;
            this.collectionReminderDay = "";
            this.hasReturnReminder = false;
            this.returnReminderDay = "";
            this.holidayTemplate = "";
            this.maxBookingPerPassYearly = "";
            this.maxBookingPerPassQuarterly = "";
            this.isAllowCancellation = false;
            this.cancellationDayBeforeBookingDate = "";
            this.isEticketBlockedOnPHAndEve = false;
        }
    },

    created() {
        if (this.role != "admin") {
            this.$router.replace({ name: "home" });
        }
        this.getCompanies();
        this.getCorporatePassOption();
    }
}
</script>

<style scoped>
.fit-content {
    max-width: fit-content;
}

input[type="checkbox"],
label[for] {
    cursor: pointer;
}

.pt-3px {
    padding-top: 3px;
}

.mw-20px {
    max-width: 20px;
}

.px-10px {
    padding-left: 10px;
    padding-right: 10px;
}

w-70px {
    width: 70px;
}
</style>


// WEBPACK FOOTER //
// src/components/Corppass/ManagePassOption.vue